module.exports = __webpack_public_path__ + "img/ht_icon_modification.83ac2d19.svg";